import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Check } from 'react-feather';
import imgFallback from 'src/utils/image';
import { classNames } from 'src/utils/helpers';

function ParagraphWithImage({ paragraph, isEven }) {
  return (
    <Col xs={12} className="py-2">
      <Row className="align-items-center justify-content-start">
        <Col xs={12} md={{ span: 6 }}>
          <div className="position-relative">
            <div className="position-relative d-flex">
              <GatsbyImage alt={paragraph.image?.alt ?? ''} image={paragraph.image?.image?.asset?.gatsbyImageData ?? imgFallback} />,
            </div>
          </div>
        </Col>

        <Col
          xs={12}
          md={{ span: 6, order: isEven ? 'first' : null }}
          className={classNames({
            'pr-md-6': isEven,
            'pl-md-6': !isEven,
          })}
        >
          <h4 className="mt-md-0 mb-3 mt-4">{paragraph.title}</h4>
          <div>
            {paragraph.paragraphs.map((contentItem, i) => (
              <div key={i} className="d-flex my-1">
                <div>
                  <div
                    className="rounded-circle d-inline-flex mr-2 text-white"
                    style={{
                      backgroundColor: '#773CF5',
                      padding: '2px',
                    }}
                  >
                    <Check size={11} strokeWidth={2.5} />
                  </div>
                </div>
                <div className="text-muted">{contentItem}</div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Col>
  );
}

export default ParagraphWithImage;
